jQuery_T4NT(document).ready(function($) {

     /**
     * Variant selection changed
     */
	  $( document ).on( "variant:change", function( evt, variant ) {
	    //console.log( variant );
	  });
  $('#item_1586767100450 a').on('click',function(){
  	$('html,body').animate({
       scrollTop: $("#shopify-section-template--15638957752533__1581507993250").offset().top
    });
  })
  
  $(document).ready(function() {
    $('body').on('click', '#agree', function() {
      if ($(this).is(':checked')) {
        $('.popup-wrap').fadeOut(500);
      }
    });
    $('body').on('click', '[register], [name="register"]', function() {
      if ($('#agree').is(':checked')) {
        // $(this).submit();
        // $('.popup-wrap').fadeOut(500);
      }
      else {
        $('.popup-wrap').fadeIn(500);
        //alert("You must agree with the terms and conditions of sales to check out.");
        return false;
      }
    });
  });
  

});